var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative md:flex mb-2 last-child:mb-0 text-base",class:{
    'w-full': !_vm.halfWidth && !_vm.inline,
    'w-1/2': _vm.halfWidth,
    'mb-6': _vm.loose,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }